<div id="main" class="page-wrapper l-dashboard" >
  <header class="l-header bg-blue-dark relative">
    <app-header></app-header>
    <div class="elm-overlay" [style.height.px]="maxHight" [ngClass]="{ 'is-active': dropActive }">
    </div>
  </header>
  <aside class="l-aside bg-white" id="l-aside">
    <app-aside [clickShadow]="ifClickShadow" (overlayActive)="dropDownAside($event)"></app-aside>
  </aside>
  <div class="l-content">
    <div class="elm-overlay" (click)="clickShadow()"
    [ngClass]="{ 'is-active': dropActiveAside}"></div>
    <!--<app-nav-dash (overlayActive)="dropDown($event)" class="bg-white app-d-nav-actions"></app-nav-dash>-->
    <app-nav-dash class="bg-white app-d-nav-actions"></app-nav-dash>
    <section class="sect-main bg-gray-light">
      <router-outlet></router-outlet>
    </section>
  </div>
  <footer class="l-footer text-center">
    <app-footer></app-footer>
  </footer>
</div>
